export default {
  id: 236,
  title: 'Target #236 - Concentrate',
  url: 'https://cssbattle.dev/play/236',
  colors: ['#F8B140', '#2F434E', '#CF6939'],
  solution:
    '<p a><p b><p c><style>body{background:#f8b140}p{position:fixed;margin:0;top:0;width:80;height:300;background:radial-gradient(circle,#cf6939 15px,#f8b140 15px 45px,#2f434e 45px 75px,#cf6939 75px 105px,#f8b140 105px)}p[a]{left:60}p[b]{left:160}p[c]{left:260',
}
